import { EvtHeader } from "components/header";
import React from "react";
import GradeForm from "../form";

const CreateGrade = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Grade" />
      <div className="p-6 max-w-2xl">
        <GradeForm />
      </div>
    </div>
  );
};

export default CreateGrade;
